// Customizable Area Start
import React from "react";
import { Box, Button, CircularProgress, Typography } from "@material-ui/core";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { StepConfirmProps } from "./types";

const StepConfirm: React.FC<StepConfirmProps> = ({
  isNewAccount,
  loading,
  onPost,
}) => (
  <Box style={{ textAlign: "center" }}>
    {/* Success icon */}
    <Box
      style={{
        margin: "0 auto 20px",
        width: 72,
        height: 72,
        borderRadius: "50%",
        backgroundColor: "#F0FDF4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CheckCircleOutlineIcon style={{ fontSize: 44, color: "#16A34A" }} />
    </Box>

    <Typography
      style={{
        fontSize: 22,
        fontWeight: 700,
        fontFamily: "Inter",
        marginBottom: 12,
        color: "#0F172A",
      }}
    >
      Congratulations!
    </Typography>

    <Typography
      variant="body2"
      style={{
        fontFamily: "Inter",
        color: "#64748B",
        marginBottom: 36,
        lineHeight: 1.7,
        maxWidth: 300,
        margin: "0 auto 36px",
      }}
    >
      {isNewAccount
        ? "Your profile has been created. Click the button below to post your comment."
        : "You have been verified. Click the button below to post your comment."}
    </Typography>

    <Button
      variant="contained"
      fullWidth
      disabled={loading}
      onClick={onPost}
      style={{
        backgroundColor: "#000",
        color: "#fff",
        borderRadius: 24,
        textTransform: "none",
        padding: "14px 0",
        fontSize: 16,
        fontFamily: "Inter",
        fontWeight: 600,
      }}
    >
      {loading ? (
        <CircularProgress size={22} style={{ color: "#fff" }} />
      ) : (
        "Post Comment"
      )}
    </Button>
  </Box>
);

export default StepConfirm;
// Customizable Area End
